export function hasMarkedCurrentMessage({
  otherMessage,
  seen,
  username,
  otherUser,
  seenAtMessage,
}) {
  return (
    Boolean(otherMessage) &&
    seen[otherUser] === username &&
    seenAtMessage === otherMessage
  );
}

export function shouldShowSeenButton({
  otherMessage,
  seen,
  username,
  otherUser,
  seenAtMessage,
}) {
  return Boolean(otherMessage) && !hasMarkedCurrentMessage({
    otherMessage,
    seen,
    username,
    otherUser,
    seenAtMessage,
  });
}
